import { motion } from 'motion/react';
import { Menu, X } from 'lucide-react';
import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ThemeSwitcher } from '../ThemeSwitcher';
import { useAuth } from '../../hooks/useAuth';

export const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const { user } = useAuth();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { name: 'O Akademii', href: '/o-akademii' },
    { name: 'Blog', href: '/blog' },
    { name: 'Nasza historia', href: '/nasza-historia' },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-background/95 backdrop-blur-md border-b border-white/10 py-3' : 'bg-background/80 backdrop-blur-sm border-b border-white/5 py-4'
        }`}
    >
      <div className="max-w-7xl mx-auto px-6 flex items-center justify-between">
        {/* Logo */}
        <div className="flex items-center gap-3">
          <Link to="/">
            <img
              src="/logo.png"
              alt="Akademia Milionerów"
              width="260"
              height="65"
              className="h-12 w-auto object-contain cursor-pointer"
            />
          </Link>
        </div>

        {/* Desktop Nav */}
        <div className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <Link
              key={link.name}
              to={link.href}
              className="text-sm font-medium text-text-muted hover:text-primary transition-colors uppercase tracking-widest"
            >
              {link.name}
            </Link>
          ))}
          {user ? (
            <Link to="/platforma" className="px-6 py-2 bg-primary text-primary-foreground font-bold text-sm uppercase tracking-wider rounded-full hover:bg-primary/90 transition-all shadow-[0_0_20px_rgba(var(--color-primary),0.3)]">
              Platforma VOD
            </Link>
          ) : (
            <Link to="/zaloguj" className="px-6 py-2 bg-primary text-primary-foreground font-bold text-sm uppercase tracking-wider rounded-full hover:bg-primary/90 transition-all shadow-[0_0_20px_rgba(var(--color-primary),0.3)]">
              Logowanie
            </Link>
          )}
        </div>

        {/* Mobile Menu Toggle */}
        <button
          className="md:hidden text-text-main"
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
        >
          {isMobileMenuOpen ? <X /> : <Menu />}
        </button>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <motion.div
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          className="absolute top-full left-0 right-0 bg-surface border-b border-border p-6 md:hidden flex flex-col gap-4 shadow-2xl"
        >
          {navLinks.map((link) => (
            <Link
              key={link.name}
              to={link.href}
              onClick={() => setIsMobileMenuOpen(false)}
              className="text-lg font-medium text-text-main hover:text-primary"
            >
              {link.name}
            </Link>
          ))}
          {user ? (
            <Link to="/platforma" className="w-full py-3 bg-primary text-primary-foreground font-bold uppercase tracking-wider rounded-xl text-center">
              Platforma VOD
            </Link>
          ) : (
            <Link to="/zaloguj" className="w-full py-3 bg-primary text-primary-foreground font-bold uppercase tracking-wider rounded-xl text-center">
              Logowanie
            </Link>
          )}
        </motion.div>
      )}
    </nav>
  );
};
